import { render } from "./RecieversGroupComponent.vue?vue&type=template&id=1a77c7b8&scoped=true"
import script from "./RecieversGroupComponent.vue?vue&type=script&lang=js"
export * from "./RecieversGroupComponent.vue?vue&type=script&lang=js"

import "./RecieversGroupComponent.vue?vue&type=style&index=0&id=1a77c7b8&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a77c7b8"]])

export default __exports__